
import { Row, Col, Typography, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import usePostulaciones from './hooks/HookPostulaciones';
import ListarEmpleos from './ListEmpleos/ListarEmpleos';

const { Title } = Typography;

const EmpleosDisponibles = () => {
    const { loading, empleosFiltrados, busqueda, setBusqueda, postularEgresadoAEmpleo } = usePostulaciones();
    return (
        <>
            <Row gutter={[16, 16]}>
                <Col span={24}>
                    <Title level={2} style={{ marginBottom: '30px', textAlign: 'center' }}>
                        Ofertas laborales
                    </Title>
                </Col>
                <Col span={24}>
                    <Input
                        size="large"
                        placeholder="Buscar por empresa, título, ubicación, habilidades o tipo de empleo..."
                        prefix={<SearchOutlined />}
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                        allowClear
                    />
                </Col>
                <Col span={24}>
                    <ListarEmpleos loading={loading} empleosFiltrados={empleosFiltrados} postularEgresadoAEmpleo={postularEgresadoAEmpleo} />
                </Col>
            </Row>
        </>
    );
};

export default EmpleosDisponibles;